import { type AxiosRequestConfig } from 'axios'

const getUserSummaryInfo = (id?: string): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: id ? `/users/${id}/info/summary` : '/user/info/summary'
  }
}

export { getUserSummaryInfo }
